/**
 * Analytics
 * Analytics API
 *
 * The version of the OpenAPI document: 1.0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 0 = Unknown, 1 = DeviceOnline, 2 = DeviceOffline, 3 = FirmwareUpdated, 4 = Provisioned, 5 = SeverityRaised, 6 = SeverityResolved
 */
export enum ActivityKind {
    Unknown = 'Unknown',
    DeviceOnline = 'DeviceOnline',
    DeviceOffline = 'DeviceOffline',
    FirmwareUpdated = 'FirmwareUpdated',
    Provisioned = 'Provisioned',
    SeverityRaised = 'SeverityRaised',
    SeverityResolved = 'SeverityResolved'
}

